import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./Pages/Home";
import BlogRoutes from "./Routes/BlogRoutes"; // Sub Routes for BlogRoutes
import ContactMe from "./Pages/ContactMe";
import SocialMedia from "./Pages/SocialMedia";
import Projects from "./Pages/ProjectPage";

import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";

import Error from "./Pages/ErrorPage";
import ScrollToTop from "./Components/Package/ScrollToTop";
import ResponsiveError from "./Components/ResponsiveError";

function App() {
  const [showError, setShowError] = useState(false); // Add this state variable

  useEffect(() => {
    // Function to check and toggle the error based on screen width
    const handleResize = () => {
      if (window.innerWidth < 350) { // Adjust this threshold as needed
        setShowError(true);
      } else {
        setShowError(false);
      }
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Disable right-click context menu
    document.addEventListener("contextmenu", handleContextMenu);

    // Initial check
    handleResize();

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  // Function to handle right-click context menu
  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      {showError ? (
        <Routes>
          <Route path="/*" element={<ResponsiveError />} />
        </Routes>
      ) : (
        <div>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/socialMedia" element={<SocialMedia />} />
            <Route path="/blog/*" element={<BlogRoutes />} /> {/* Sub Routes for BlogRoutes */}
            <Route path="/contactMe" element={<ContactMe />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/*" element={<Error />} />
          </Routes>
          <Footer />
        </div>
      )}
    </BrowserRouter>
  );
}

export default App;
